import { useLocation, useNavigate } from "react-router";
import { useEffect, useRef } from "react";

type SessionData = {
  sessionId: string | null;
  sessionTitle: string | null;
};

const DeleteModal = ({
  renameModalProps,
  deleteActiveModal,
  setActiveDeleteModalHandler,
  deleteSessionHandler,
}: {
  renameModalProps: SessionData;
  deleteActiveModal: boolean;
  setActiveDeleteModalHandler: (prop: boolean) => void;
  deleteSessionHandler: (sessionId: string) => void;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (deleteActiveModal) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [deleteActiveModal]);
  
  const handleDelete = () => {
    setActiveDeleteModalHandler(false);
    deleteSessionHandler(
      renameModalProps.sessionId ? renameModalProps.sessionId : ""
    );
    if (pathName === `/session/vibe/${renameModalProps.sessionId}`) {
      navigate("/session");
    }
  };

  const handleClose = () => {
    setActiveDeleteModalHandler(false);
  };

  return (
    <dialog ref={dialogRef} className="modal" onClose={handleClose}>
      <div className="modal-box">
        <h3 className="text-lg font-bold">Delete Project</h3>
        <p className="py-4">
          Are you sure you want to delete this project?
          <br />
          <span className="font-medium text-base-content mt-2 block">
            "{renameModalProps.sessionTitle}"
          </span>
        </p>
        
        <div className="modal-action">
          <button
            className="btn"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-error"
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button type="button" onClick={handleClose}>close</button>
      </form>
    </dialog>
  );
};

export default DeleteModal;
